import React, { lazy, Suspense, useState } from 'react';
import { Box } from '@mui/material';
import { exportFormats } from '../data/exportData';
import { ExportPageSkeleton } from '../components/ExportPageSkeleton';
import { ExportColumn } from '../types';
import { usePurchaseExport } from '../hooks/usePurchaseExport';
import { useItemExport } from '../hooks/useItemExport';

// Lazy load components and data
const ExportHeader = lazy(() => import('../components/exportForm/ExportHeader').then((m) => ({ default: m.ExportHeader })));
const ColumnSelector = lazy(() => import('../components/exportForm/ColumnSelector').then((m) => ({ default: m.ColumnSelector })));
const ExportActions = lazy(() => import('../components/exportForm/ExportActions').then((m) => ({ default: m.ExportActions })));
const LoadingModal = lazy(() => import('../../../components/_components').then((m) => ({ default: m.LoadingModal })));

interface PurchaseExportPageProps {
  exportOptions?: string;
  selectedArray?: number[];
  onExit?: () => void;
  startDate?: number;
  endDate?: number;
  columns: ExportColumn[];
}
export const ItemExportPage: React.FC<PurchaseExportPageProps> = ({ startDate, selectedArray, endDate, onExit, columns }) => {
  const {
    selected,
    selectedModule,
    setSelectedModule,
    dateRange,
    errors,
    isDateChangeable,
    exportStatus,
    isOpen,
    setStatus,
    status,
    downloadCallback,
    handleChange,
    handleSelectAll,
    handleDateRangeChange,
    handleExport,
    handleCloseModal,
  } = useItemExport({ startDate, endDate, selectedArray });
  console.log(isDateChangeable, 'isDateChangeable');

  return (
    <Box>
      <Suspense fallback={<ExportPageSkeleton />}>
        <ExportHeader
          // title={title}
          selectedModule={selectedModule}
          setSelectedModule={setSelectedModule}
          dateRange={dateRange}
          handleDateRangeChange={handleDateRangeChange}
          moduleOptions={[...exportFormats]}
          errors={errors}
          isDateChangeable={isDateChangeable}
          hideDate={true}
          status={status}
          setStatus={setStatus}
        />

        <ColumnSelector columns={columns} selected={selected} handleChange={handleChange} handleSelectAll={handleSelectAll} />

        <ExportActions onExport={handleExport} exportDisabled={!selectedModule || selected.length === 0 || !dateRange} onExit={onExit} />

        <LoadingModal
          open={isOpen}
          status={exportStatus}
          onClose={handleCloseModal}
          downloadCallback={downloadCallback}
          loadingTitle="Exporting Data"
          successTitle="Export Completed"
          errorTitle="Export Failed"
          loadingMessages={['Preparing export...', 'Processing data...', 'Generating file...', 'Almost ready...', 'Finalizing export...']}
          successMessage="Your file has been downloaded successfully!"
          errorMessage="Failed to export file. Please try again."
        />
      </Suspense>
    </Box>
  );
};
